import { getToken } from './auth';

/** API 基础地址：本地走 Vite 代理，生产由环境变量注入 */
const RAW_BASE = import.meta.env.VITE_API_BASE_URL ?? '/api/v1';
export const API_BASE = RAW_BASE.replace(/\/$/, '');

export interface ApiResponse<T> {
  ok: boolean;
  data?: T;
  error?: { code: string; message: string };
}

/** 统一请求封装，自动携带 JWT */
export async function api<T>(path: string, options: RequestInit = {}): Promise<ApiResponse<T>> {
  const url = `${API_BASE}${path.startsWith('/') ? path : `/${path}`}`;
  const token = getToken();

  try {
    const res = await fetch(url, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        ...options.headers,
      },
    });

    const json = (await res.json().catch(() => null)) as ApiResponse<T> | null;
    return json ?? { ok: false, error: { code: 'PARSE_ERROR', message: '响应解析失败' } };
  } catch (e) {
    return {
      ok: false,
      error: {
        code: 'NETWORK_ERROR',
        message: e instanceof Error ? e.message : '网络异常',
      },
    };
  }
}

/** 提取错误文案 */
export function errMsg<T>(res: ApiResponse<T>, fallback = '操作失败'): string {
  return res.error?.message ?? fallback;
}
